import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import {Link,NavLink,withRouter} from "react-router-dom"
import HomeIcon from '@mui/icons-material/Home';
import Resumedata from '../../Utilitize/Resumedata';
import Mybutton from '../Button/Mybutton';
import TelegramIcon from '@mui/icons-material/Telegram';
import './Header.css'
function Header() {
    return (
        <Navbar bg="light" expand="lg" sticky="top" className="header">
           <Nav.Link as={NavLink} to="/" className="header_home" >
               <Navbar.Brand className="header_brand" style={{display:"flex",justifyContent:"center",alignItems:"center",marginLeft:"12px"}}>
                 <HomeIcon/>
               </Navbar.Brand>
           </Nav.Link>


           <Navbar.Toggle/>
 
           <Navbar.Collapse>
               <Nav className="header_left">
                    <Nav.Link as={NavLink} to="/resume" className="mynav" activeStyle={{ color:'rgb(69, 180, 245)' }}>Resume</Nav.Link>
                    <Nav.Link as={NavLink} to="/projects" className="mynav" activeStyle={{ color:'rgb(69, 180, 245)' }}>Projects</Nav.Link>
                    <Nav.Link as={NavLink} to="/blog" className="mynav" activeStyle={{ color:'rgb(69, 180, 245)' }}>Blog</Nav.Link>
                    <Nav.Link as={NavLink} to="/contact" className="mynav" activeStyle={{ color:'rgb(69, 180, 245)' }}>Contact</Nav.Link>
               </Nav>
              

              <div className="header_right">
                {Object.keys(Resumedata.socials).map((key)=>{
                        return(
                          <a href={Resumedata.socials[key].link} target="_blank">{Resumedata.socials[key].icon}</a>

                        )
                 })}  

            <Mybutton link="https://drive.google.com/file/d/1BqVucFH4yIv2Cb7n-5L4jn4XzBUvQ7lv/view?usp=sharing" text="See my resume" icon={<TelegramIcon/>}/>
              </div>
           </Navbar.Collapse>



        </Navbar>
    )
}

export default withRouter(Header)
